const parseBooleanEnv = (value: string | undefined, defaultValue: boolean): boolean => {
  if (value === undefined || value === '') {
    return defaultValue;
  }
  return value.toLowerCase() === 'true';
};

const isProd = process.env.REACT_APP_DEPLOY_ENV === 'prod';

// Change these to alter how often forms are shown, especially in prod!

const formThresholds = {
  prod: 0,
  dev: 0.7,
};

export const config = {
  path: 'olympics/',
  aiInfoArticleUrl: 'https://www.is.fi/urheilu/art-2000011788602.html',
  feedbackFormThreshold: isProd ? formThresholds.prod : formThresholds.dev,
  featureFlags: {
    // Hide all insights in the UI
    enableInsights: isProd
      ? parseBooleanEnv(process.env.REACT_APP_FEATURE_FLAG_ENABLE_INSIGHTS, true)
      : parseBooleanEnv(process.env.REACT_APP_FEATURE_FLAG_DEV_ENABLE_INSIGHTS, true),

    // Hide the whole app
    enableApp: isProd
      ? parseBooleanEnv(process.env.REACT_APP_FEATURE_FLAG_ENABLE_APP, true)
      : parseBooleanEnv(process.env.REACT_APP_FEATURE_FLAG_DEV_ENABLE_APP, true),

    // Enable Reuters insights (insights where URLs don't contain is.fi)
    enableReutersInsight: isProd
      ? parseBooleanEnv(process.env.REACT_APP_FEATURE_FLAG_ENABLE_REUTERS, true)
      : parseBooleanEnv(process.env.REACT_APP_FEATURE_FLAG_DEV_ENABLE_REUTERS, true),
  },
};
